import React from 'react';
import {
  FilterFacetCount,
  FilterOptionLi,
  FilterOptionRadio,
} from 'src/pages/CatalogPage/components/FilterMenu/FilterMenuOption/FilterMenuOption.style';
import { IAuctionMappings } from 'src/pages/CatalogPage/Catalog.i';
interface IFilterOption {
  option: {
    name: string,
    slug: string,
    value: string,
  };
  setFilter?(slug: string, field: keyof IAuctionMappings): void;
  count?: number;
  checked: boolean;
  field: keyof IAuctionMappings;
  addedStyle?: string;
}

export const FilterOption = (props: IFilterOption) => {
  const { name, value, slug } = props.option;
  const { field, checked, addedStyle } = props;
  const disabled = props.count < 1 && value !== 'All' ? true : false;
  return (
    <FilterOptionLi key={value} addedStyle={addedStyle}>
      <FilterOptionRadio
        value={value}
        onChange={() => props.setFilter(slug, field)}
        name={field}
        checked={checked}
        disabled={disabled}
      >
        {name}
        {value !== 'All' && <FilterFacetCount>({props.count})</FilterFacetCount>}
      </FilterOptionRadio>
    </FilterOptionLi>
  );
};
